<template>
  <div>
    <div class="warehouseFeeBill">
      <!-- 费用管理 长存仓库账单 -->
      <baseBreadcrumb :page="$t('message.longTermStorageFeeBill')" :menu="$t('message.costManagement')">
      </baseBreadcrumb>
      <div class="body" v-show="!isDetail">
        <div class="search">
          <!-- 客户ID/客户名称 -->
          <div class="item">
            <el-input v-model="datas.user_id" :placeholder="$t('message.customerID_CustomerName')"></el-input>
          </div>
          <!-- 开始日期 -->
          <div class="item">
            <el-date-picker v-model="datas.start_date" type="date" value-format="yyyy-MM-dd"
              :placeholder="$t('message.startDate')">
            </el-date-picker>
          </div>
          <!-- 结束日期 -->
          <div class="item">
            <el-date-picker v-model="datas.end_date" type="date" value-format="yyyy-MM-dd"
              :placeholder="$t('message.endTime')">
            </el-date-picker>
          </div>
          <!-- 结算状态 -->
          <div class="item">
            <el-select v-model="datas.status" :placeholder="$t('message.settlementStatus')">
              <el-option label="待结算" value="0"></el-option>
              <el-option label="已结算" value="1"></el-option>
              <!-- <el-option label="已取消" value="2"></el-option> -->
            </el-select>
          </div>
          <!-- 查询按钮 -->
          <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
          <!-- 重置按钮 -->
          <el-button @click="reset">{{ $t('message.reset') }}</el-button>
        </div>
        <div class="table">
          <ol style="background-color: #EDEFF4;">
            <li class="flex05">No</li>
            <!-- 客户信息 -->
            <li>{{ $t('message.userInfo') }}</li>
            <!-- 账单号 -->
            <li>{{ $t('message.billNumber') }}</li>
            <!-- 计费箱数 -->
            <li>{{ $t('message.feeBoxNumber') }}</li>
            <!-- 商品数量 -->
            <li>{{ $t('message.productNumber') }}</li>
            <!-- 长存仓储费总金额-->
            <li>{{ $t('message.warehouseFeeTotalAmount') }}</li>
            <!-- 结算状态 -->
            <li>{{ $t('message.settlementStatus') }}</li>
            <!-- 账单日期 -->
            <li>{{ $t('message.billDate') }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li class="flex05">{{ item.rowNumber }}</li>
            <!-- 客户信息 -->
            <li>
              <div>
                <p>ID:{{ item.user_id }}</p>
                <p>{{ item.realname }}</p>
              </div>
            </li>
            <!-- 账单号 -->
            <li>
              <el-button type="text" @click="showDetail(item.id)">{{ item.bill_sn }}</el-button>
            </li>
            <!-- 计费箱数 -->
            <li>{{ item.box_count }}</li>
            <!-- 商品数量 -->
            <li>{{ item.goods_count }}</li>
            <!-- 长存仓储费总金额-->
            <li>{{ item.total_fee }}</li>
            <!-- 结算状态 -->
            <li>{{ item.status_name }}</li>
            <!-- 账单日期 -->
            <li>{{ item.bill_date }}</li>
          </ul>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total" :page-size="datas.pageSize"
            v-model:current-page="datas.page" @size-change="handleSizeChange" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 详情 -->
    <Detail v-show="isDetail" ref="detail"></Detail>
  </div>
</template>
<script>
import Detail from './conponents/detail.vue'
export default {
  components: {
    Detail,
  },
  data() {
    return {
      isDetail: false,
      tableData: [],
      total: 0,
      datas: {
        bill_type: 'cost',
        user_id_or_name: '',
        bill_sn: '',
        status: '',
        bill_date_start: '',
        bill_date_end: '',
        page: 1,
        pageSize: 10,
      }
    }
  },

  created() {
    this.wmsStorageBillList();
  },
  methods: {
    // 长存仓库账单-获取计费类型列表
    wmsStorageBillList() {
      this.$api.costManagementApi.wmsStorageBillList(this.datas).then(res => {

        this.tableData = res.data.data;
        this.total = res.data.total;
      })
    },
    // 分页-每页条数改变
    handleSizeChange(val) {
      this.datas.page = 1
      this.datas.pageSize = val;
      this.wmsStorageBillList();
    },
    // 分页-当前页改变
    handleCurrentChange(val) {
      this.datas.page = val;
      this.wmsStorageBillList();
    },
    // 查询
    search() {
      this.datas.page = 1
      this.wmsStorageBillList();
    },
    // 重置
    reset() {
      this.datas = {
        user_id_or_name: '',
        bill_sn: '',
        status: '',
        bill_date_start: '',
        bill_date_end: '',
        page: 1,
        pageSize: 10,
        bill_type: 'cost',
      }
      this.wmsStorageBillList();
    },
    // 长存仓库账单-获取详情
    showDetail(bill_id) {
      this.$refs.detail.bill_id = bill_id
      this.$refs.detail.wmsStorageBillDetail()
      this.isDetail = true
    },



  }
}
</script>
<style scoped lang="scss">
.warehouseFeeBill {
  .search {
    margin-bottom: 20px;
    display: flex;

    .item {
      width: 200px;
      margin-right: 20px;

      .el-date-editor {
        width: 100%;
      }
    }
  }

  .table {
    .flex05 {
      flex: 0.5;
    }

    .flex2 {
      flex: 2;
    }

    ol {
      background: #DCDFE6;
      height: 56px;
      line-height: 56px;
      color: #666666;
    }

    ul {
      padding: 20px 0;
      background-color: #fff;
      text-align: center;



      p {
        line-height: 22px;
        margin-bottom: 6px;

        .el-button {
          width: 80px;
          padding: 11px 0;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .template {
      width: 100%;
      text-align: left;

      .row {
        margin-bottom: 12px;
      }
    }
  }
}
</style>
